import { DatePicker } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import Config from "../../../../Config";

import FormBloc from "../../../../bloc/forms_bloc";
import UtilBloc from "../../../../bloc/util_bloc";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import AppTextField from "../../../component/app_text_field/app_text_field";
import "./proposal_form.css";
import AppCheckboxGroup from "../../../component/app_checkbox/app_checkbox";
import FormsBloc from "../../../../bloc/forms_bloc";
import { numberValidation } from "../../../component/app_validation";

class ForeignQuestionaire extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            //form start
            basedInMalaysia: [],
            countryList: [],
            foreignData: {
                arriveDate: null,
                stayDuration: null,
                statusInMalaysia: null,
                positionNduties: null,
                isBank: "No",
                isProperty: "No",
                isInvestment: "No",
                isBusiness: "No",
                isRelatives: "No",
                isDunHave: "No",
                isSpouseMalaysian: null,
                spouseOccupation: null,
                spouseNationality: null,
                familyMember: null,
                isTravel: null,
                reasonForCert: null,
                isBankDetails: null,
                isPropertyDetails: null,
                isInvestmentDetails: null,
                isBusinessDetails: null,
                isRelativesDetails: null,
                travelFreq: null,
                otherStatusInMalaysia: null,
            },
            //form end

            errorMessage: 'Fill in the required field.',
            isUpdate: false,
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.foreignData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        FormBloc.getCountryList().then((res) => {
            this.setState({ countryList: res.data });
        })
        this.setState({ foreignData: stateData })
    }

    async getFormData() {
        let occupationList = await FormsBloc.getOccupationList();
        this.setState({ occupationOpt: occupationList.data });
    }

    getFormFields() {
        return this.props.fields;
    }

    //handle change start
    handleValueChange = (field, val) => {
        let data = this.state.foreignData;
        data[field] = val;

        if (field === "isSpouseMalaysian") {
            if (val === "Yes") {
                data[field] = val
                data["spouseNationality"] = "MALAYSIA"

            } else {
                data[field] = val
                data["spouseNationality"] = null
            }
        }
        if (field === "isTravel" && val === 'No') {
            data['travelFreq'] = null;
        }
        if (field === 'arriveDate') {
            if (val && val._d) {
                data[field] = val
            } else {
                data[field] = null
            }
        }
        this.setState({ foreignData: data }, () => {
            this.onValidateForm();
        });
    }

    handleCheckBoxGroupValueChange = (val) => {
        this.setState({ basedInMalaysia: val }, () => {
            // This callback function will run after setState is done
            this.onValidateForm();
        });
    }
    handleCheckBoxValueChange = (field, val, childValue) => {
        if (val === true) {
            this.setState((prevState) => ({
                foreignData: {
                    ...prevState.foreignData,  // Maintain existing state
                    [field]: "Yes"
                }
            }), () => {
                this.onValidateForm();
            });
        } else {
            if (field === 'isBank' || field === 'isProperty' || field === 'isInvestment' || field === 'isBusiness' || field === 'isRelatives') {
                this.setState((prevState) => ({
                    foreignData: {
                        ...prevState.foreignData,  // Maintain existing state
                        [field]: "No",
                        [`${field}Details`]: null
                    }
                }), () => {
                    this.onValidateForm();
                });
            } else {
                this.setState((prevState) => ({
                    foreignData: {
                        ...prevState.foreignData,  // Maintain existing state
                        [field]: "No"
                    }
                }), () => {
                    this.onValidateForm();
                });
            }

        }
        if (childValue) {
            if (childValue === "All") {
                this.setState((prevState) => ({
                    foreignData: {
                        ...prevState.foreignData,  // Maintain existing state
                        isBank: "No",
                        isProperty: "No",
                        isInvestment: "No",
                        isBusiness: "No",
                        isRelatives: "No",
                        isBankDetails: null,
                        isPropertyDetails: null,
                        isInvestmentDetails: null,
                        isBusinessDetails: null,
                        isRelativesDetails: null,
                    }

                }), () => {
                    this.onValidateForm();
                });
            }
            else
                this.setState({ [childValue]: null })
        }

    }
    handleExtraFieldFormValueChange = (field, val) => {
        this.setState({ [field]: val });
        this.onValidateForm();

    }

    onValidateForm = () => {
        const { foreignData } = this.state;
        const { maritalStatus } = this.props;
        const {
            isBank, isProperty, isBusiness, isInvestment, isRelatives, isDunHave
        } = this.state.foreignData;
        let validated = UtilBloc.foreignerDetailsDataValidation(foreignData, this.props.maritalStatus);

        this.setPropValidation(validated);
        this.setPropValue();
    }

    setPropValue = () => {
        const { foreignData, isBankDetails, isPropertyDetails, isBusinessDetails, isRelativesDetails, isInvestmentDetails, otherStatusInMalaysia, travelFreq } = this.state;
        let valueobj = {
            arriveDate: foreignData.arriveDate,
            stayDuration: foreignData.stayDuration,
            statusInMalaysia: foreignData.statusInMalaysia,
            positionNduties: foreignData.positionNduties,
            isBank: foreignData.isDunHave === "Yes" ? "No" : foreignData.isBank,
            isProperty: foreignData.isDunHave === "Yes" ? "No" : foreignData.isProperty,
            isInvestment: foreignData.isDunHave === "Yes" ? "No" : foreignData.isInvestment,
            isBusiness: foreignData.isDunHave === "Yes" ? "No" : foreignData.isBusiness,
            isRelatives: foreignData.isDunHave === "Yes" ? "No" : foreignData.isRelatives,
            isSpouseMalaysian: foreignData.isSpouseMalaysian,
            spouseOccupation: foreignData.spouseOccupation,
            spouseNationality: foreignData.spouseNationality,
            familyMember: foreignData.familyMember,
            isTravel: foreignData.isTravel,
            reasonForCert: foreignData.reasonForCert,
            isBankDetails: foreignData.isBankDetails, //
            isPropertyDetails: foreignData.isPropertyDetails,
            isInvestmentDetails: foreignData.isInvestmentDetails,
            isBusinessDetails: foreignData.isBusinessDetails,
            isRelativesDetails: foreignData.isRelativesDetails,
            travelFreq: foreignData.travelFreq,
            otherStatusInMalaysia: foreignData.otherStatusInMalaysia,
        }

        this.props.onChange(valueobj);
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    async handleFormSubmit() {

    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    // form element start
    arriveDate() {
        return (
            <div className="mt-1">
                When did you arrive in Malaysia?
                <DatePicker
                    onChange={(e) => this.handleValueChange(this.getFormFields().arriveDate, e)}
                    style={{ height: '48px', width: '100%', marginTop: '1vh' }}
                    placeholder="DD/MM/YYYY"
                    format={'DD/MM/YYYY'}
                    value={this.state.foreignData?.arriveDate}
                />
                {/* {
                    this.showerror(this.state.foreignData.arriveDate) &&
                    <AppFieldError text={this.state.errorMessage} />
                } */}
            </div>
        )
    }
    stayDuration() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.stayDuration}
                type={'text'}
                placeholder={'00 years'}
                value={this.state.foreignData.stayDuration}
                onChange={(e) => this.handleValueChange(this.getFormFields().stayDuration, e)}
                onValidate={(value) => { return !UtilBloc.isContainNumberOnly(value) }}
                error={this.showerror(this.state.foreignData.stayDuration)}
                errorMessage={numberValidation(this.state.foreignData.stayDuration)}
            />
        )
    }

    statusInMalaysia() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.statusInMalaysia}
                value={this.state.foreignData.statusInMalaysia}
                placeholder={"Select official status..."}
                options={Config.quotation.optionItem.statusInMalaysia}
                onChange={(e) => e !== "Others" ?
                    this.setState((prevState) => ({
                        otherStatusInMalaysia: null,
                    }), () => { this.handleValueChange(this.getFormFields().statusInMalaysia, e) })
                    : this.handleValueChange(this.getFormFields().statusInMalaysia, e)}

            />

        )
    }

    otherStatusInMalaysia() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.otherStatusInMalaysia}
                type={'text'}
                placeholder={'Please enter details of your official status in Malaysia...'}
                value={this.state.otherStatusInMalaysia}
                onChange={(e) => this.handleExtraFieldFormValueChange("otherStatusInMalaysia", e)}
                error={this.showExtraFormError(this.state.foreignData.statusInMalaysia, this.state.otherStatusInMalaysia, "Others")}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    positionNduties() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.positionNduties}
                type={'text'}
                multiline={true}
                showCount
                maxLength={1000}
                placeholder={'Write about your current positions and duties you\'re handling ...'}
                value={this.state.foreignData.positionNduties}
                onChange={(e) => this.handleValueChange(this.getFormFields().positionNduties, e)}
                error={this.showerror(this.state.foreignData.positionNduties)}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    isBank() {
        return (
            <AppCheckboxGroup
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.bankOrProperty}
                options={[
                    {
                        label: 'Bank Account', value: 'Bank Account',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields().isBank,
                        checked: this.state.foreignData.isBank,
                        childValue: "isBankDetails",
                        disabled: (this.state.foreignData.isDunHave === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.foreignData.isBankDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isBankDetails, e)}
                                        error={this.showExtraFormError(this.state.foreignData.isBank, this.state.foreignData.isBankDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Property', value: 'Property',
                        handleValueChange: this.handleCheckBoxValueChange,
                        getFormField: this.getFormFields().isProperty,
                        checked: this.state.foreignData.isProperty,
                        childValue: "isPropertyDetails",
                        disabled: (this.state.foreignData.isDunHave === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.foreignData.isPropertyDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isPropertyDetails, e)}
                                        error={this.showExtraFormError(this.state.foreignData.isProperty, this.state.foreignData.isPropertyDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Investment(e.g. shares)', value: 'Investment(e.g. shares)',
                        handleValueChange: this.handleCheckBoxValueChange,
                        checked: this.state.foreignData.isInvestment,
                        getFormField: this.getFormFields().isInvestment,
                        childValue: "isInvestmentDetails",
                        disabled: (this.state.foreignData.isDunHave === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.foreignData.isInvestmentDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isInvestmentDetails, e)}
                                        error={this.showExtraFormError(this.state.foreignData.isInvestment, this.state.foreignData.isInvestmentDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Business', value: 'Business',
                        handleValueChange: this.handleCheckBoxValueChange,
                        checked: this.state.foreignData.isBusiness,
                        getFormField: this.getFormFields().isBusiness,
                        childValue: "isBusinessDetails",
                        disabled: (this.state.foreignData.isDunHave === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.foreignData.isBusinessDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isBusinessDetails, e)}
                                        error={this.showExtraFormError(this.state.foreignData.isBusiness, this.state.foreignData.isBusinessDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Relatives', value: 'Relatives',
                        handleValueChange: this.handleCheckBoxValueChange,
                        checked: this.state.foreignData.isRelatives,
                        getFormField: this.getFormFields().isRelatives,
                        childValue: "isRelativesDetails",
                        disabled: (this.state.foreignData.isDunHave === "Yes"),
                        children:
                            <div className="row m-0 w-100 mt-2 pr-0 pl-0">
                                <div className="col-lg-12 col-sm-12 pr-0 pl-0">
                                    <AppTextField
                                        type={'text'}
                                        multiline
                                        showCount
                                        maxLength={"1000"}
                                        placeholder={"Please state details..."}
                                        value={this.state.foreignData.isRelativesDetails}
                                        onChange={(e) => this.handleValueChange(this.getFormFields().isRelativesDetails, e)}
                                        error={this.showExtraFormError(this.state.foreignData.isRelatives, this.state.foreignData.isRelativesDetails, "Yes")}
                                        errorMessage={this.state.errorMessage}
                                    />
                                </div>
                            </div>
                    },
                    {
                        label: 'Don\'t have any of these', value: 'Don\'t have any of these',
                        handleValueChange: this.handleCheckBoxValueChange,
                        checked: this.state.foreignData.isDunHave,
                        childValue: "All",
                        getFormField: this.getFormFields().isDunHave,
                    },

                ]}
            />
        )
    }

    isSpouseMalaysian() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.isSpouseMalaysian}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.isConsultOrTreatment}
                            value={this.state.foreignData.isSpouseMalaysian}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().isSpouseMalaysian, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isSpouseMalaysian, 'Yes')}
                        />
                    </div>
                </div>
            </div>
        )
    }
    spouseOccupation() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.spouseOccupation}
                value={this.state.foreignData.spouseOccupation}
                placeholder={"Select occupation..."}
                options={this.state.occupationOpt}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().spouseOccupation, e)}
            />
        )
    }
    spouseNationality() {
        if (this.state.foreignData.isSpouseMalaysian === "Yes") {
            return (
                <AppTextField
                    title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.spouseNationality}
                    value={this.state.foreignData.spouseNationality}
                    disabled={true}
                    type={'text'}
                />
            )
        } else {
            return (
                <AppSelectField
                    title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.spouseNationality}
                    value={this.state.foreignData.spouseNationality}
                    showSearch={true}
                    placeholder="Select nationality..."
                    options={this.state.countryList?.length > 0 && this.state.countryList.filter((item) => item.code !== 'MYS') || []}
                    fieldNames={{ label: ('reference1'), value: ('code') }}
                    onChange={(e) => this.handleValueChange(this.getFormFields().spouseNationality, e)}
                />)
        }

    }
    familyMember() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.familyMember}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.isConsultOrTreatment}
                            value={this.state.foreignData.familyMember}
                            handleNegativePress={() => this.handleValueChange(this.getFormFields().familyMember, 'No')}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().familyMember, 'Yes')}
                        />
                    </div>
                </div>
            </div>
        )
    }
    isTravel() {
        return (
            <div style={{ fontSize: 14 }}>
                {Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.isTravel}
                <div className="row m-0 w-100 mt-2">
                    <div className="col-sm-6 col-xs-12 pr-3 pl-0">
                        <AppSelectButton
                            // title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.isConsultOrTreatment}
                            value={this.state.foreignData.isTravel}
                            handlePositivePress={() => this.handleValueChange(this.getFormFields().isTravel, 'Yes')}
                            handleNegativePress={() =>{
                                this.handleValueChange(this.getFormFields().isTravel, 'No')
                                this.handleValueChange(this.getFormFields().travelFreq, null)
                            }}

                        />
                    </div>
                </div>
            </div>
        )
    }
    travelFreq() {
        return (
            <AppTextField
                title={""}
                type={'text'}
                multiline={true}
                showCount
                maxLength={1000}
                placeholder={'Please state details of frequency and duration of visits ...'}
                value={this.state.foreignData.travelFreq}
                onChange={(e) => this.handleValueChange(this.getFormFields().travelFreq, e)}
                error={this.showExtraFormError(this.state.foreignData.isTravel, this.state.foreignData.travelFreq, "Yes")}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    reasonForCert() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.foreignQuestionaireFormTitle.reasonForCert}
                type={'text'}
                multiline={true}
                showCount
                maxLength={1000}
                placeholder={'Please state details ...'}
                value={this.state.foreignData.reasonForCert}
                onChange={(e) => this.handleValueChange(this.getFormFields().reasonForCert, e)}
                error={this.showerror(this.state.foreignData.reasonForCert)}
                errorMessage={this.state.errorMessage}
            />
        )
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>

                <div className="w-100 mt-4" >
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.arriveDate()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.stayDuration()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.statusInMalaysia()}
                        </div>
                        {this.state.foreignData.statusInMalaysia === "Others" &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.otherStatusInMalaysia()}
                            </div>}
                    </div>

                    <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                        {this.positionNduties()}
                    </div>
                    <div className="col-lg-12 col-sm-12 pr-3 pl-0 ">
                        {this.isBank()}
                    </div>
                    {this.props.maritalStatus === "Married" &&
                        <>
                            <div className="mt-2">
                                {this.isSpouseMalaysian()}
                            </div>
                            <div className="row m-0 w-100 mt-2" style={{ flexDirection: "row" }}>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.spouseOccupation()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.spouseNationality()}
                                </div>
                            </div>
                            <div className="">
                                {this.familyMember()}
                            </div>
                        </>
                    }
                    <div className="mt-3">
                        {this.isTravel()}
                    </div>
                    {
                        this.state.foreignData.isTravel === "Yes" &&
                        <div className="mt-3">
                            {this.travelFreq()}
                        </div>
                    }
                    <div className="mt-3">
                        {this.reasonForCert()}
                    </div>
                </div >
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ForeignQuestionaire));
